module.exports = __webpack_public_path__ + "static/media/forwardarrow.fb5123aa.svg";